class DataModel {
    initializeFromJSON(props) {
        for (const [prop, val] of Object.entries(props)) {
            this[prop] = val;
        }
    }

    params(skips = []) {
        const params = {};

        for (const [prop, val] of Object.entries(this)) {
            if (skips.includes(prop)) continue;
            if (val) params[prop] = val;
        }

        return params;
    }
}

export default DataModel;
